(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/row-entries.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/row-entries.js');

'use strict';

const rowPrice = svs.numbergames.rules.LOTTO.rowPrice;
const playPackages = svs.lotto.data.cms.playPackages;
const MULTI = 2;
const RowEntries = () => {
  const sortedPlayPackages = [...playPackages].sort((a, b) => a.rows - b.rows);
  const handleClick = _ref => {
    let rows = _ref.rows,
      price = _ref.price,
      jokerPrice = _ref.jokerPrice;
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(rows, "rader"),
      opt_value: price
    }, () => {
      svs.utils.url.navigate("/lotto/spela?rader=".concat(rows, "&joker=").concat(jokerPrice, "&multi=").concat(MULTI, "&dag=n"));
    });
  };
  return React.createElement("div", {
    className: "start-packages"
  }, React.createElement("div", {
    className: "packages-body-custom"
  }, React.createElement("h2", {
    className: "packages-header js-packages-header"
  }, "Vill du spela f\xE4rdiga spel?"), React.createElement("div", {
    className: "package-wrapper js-packages-wrapper"
  }, sortedPlayPackages.map(_ref2 => {
    let rows = _ref2.rows,
      jokerPrice = _ref2.jokerPrice;
    const price = rows * rowPrice * MULTI + jokerPrice;
    return React.createElement("div", {
      className: "package",
      key: rows,
      onClick: () => handleClick({
        rows,
        price,
        jokerPrice
      })
    }, React.createElement("div", {
      className: "package-rows"
    }, "".concat(rows, " rader")), React.createElement("div", {
      className: "package-price"
    }, "".concat(price, " kr")));
  }))));
};
setGlobal('svs.lotto.react.components', {
  RowEntries
});

 })(window);